import { manageTierRewardsPopup } from "./cart-popup-notification";

/**
 * Cart Gamification - Auto-add tier rewards
 */

function manageTierRewards(cart) {
  if (!cart) return;

  const cartTotal = cart.total_price;
  const cartItems = cart.items || [];

  const activeTiers = window.gamificationTiers.filter(tier => cartTotal >= tier.amount);
  const activeTierVariantIds = activeTiers.map(t => t.variantId);

  const tierVariantIds = window.gamificationTiers.map(t => t.variantId);
  const tierGiftsInCart = cartItems
    .filter(item => 
      tierVariantIds.includes(item.variant_id) && 
      item.properties?._required_validation === 'validated'
    )
    .map(item => ({ variantId: item.variant_id, key: item.key }));

  for (const tier of activeTiers) {
    const isInCart = tierGiftsInCart.some(gift => gift.variantId === tier.variantId);
    
    if (!isInCart) {
      console.log('superaste una reward');
      addTierReward(tier.variantId);
      return true;
    }
  }

  for (const gift of tierGiftsInCart) {
    const shouldBeActive = activeTierVariantIds.includes(gift.variantId);
    
    if (!shouldBeActive) {
      removeTierReward(gift.key);
      return;
    }
  }
}

function addTierReward(variantId) {
  liquidAjaxCart.add({
    items: [{
      id: variantId,
      quantity: 1,
      properties: {
        _required_validation: 'validated',
      }
    }]
  });
}

function removeTierReward(lineKey) {
  liquidAjaxCart.update({
    updates: {
      [lineKey]: 0
    }
  });
}

// Inicialización
(function init() {
  'use strict';

  if (!window.gamificationTiers?.length) {
    return;
  }

  document.addEventListener("liquid-ajax-cart:request-end", function(event) {
    const { cart, previousCart } = event.detail;

    const totalChanged = cart.total_price !== previousCart?.total_price;
    const itemCountChanged = cart.item_count !== previousCart?.item_count;

    if (totalChanged || itemCountChanged) {
      const idAdded = manageTierRewards(cart);

      if (idAdded) {
        document.body.classList.add('js-show-ajax-cart');
        return;
      }
      manageTierRewardsPopup(event.detail.requestState);
    }
  });

  if (window.liquidAjaxCart?.cart?.item_count > 0) {
    manageTierRewards(window.liquidAjaxCart.cart);
  }

  window.manageTierRewards = manageTierRewards;
})();

export { manageTierRewards };